import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, BufferingResult } from '../types';
import { mapBase } from './mapBase';

export const mapBuffering = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): BufferingResult => {
    return {
        ...mapBase(payload),
        action: triggerName,
        event_trigger: triggerName,
        thing_id: payload.payload.asset?.id || '',
        source_page: payload.payload.screen,
    };
};
